<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      clientId: '',
      apiKey: '',
      storeName: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    clientId: { required },
    apiKey: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const ozonChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.storeName || `Ozon ${this.clientId}`,
            channel: {
              type: 'ozon',
              client_id: this.clientId,
              api_key: this.apiKey,
              store_name: this.storeName,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: ozonChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.CREATE_ERROR')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.HEADER_CONTENT')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.clientId.$error }">
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.CLIENT_ID_LABEL') }}
          <input
            v-model="clientId"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.CLIENT_ID_PLACEHOLDER')"
            @blur="v$.clientId.$touch"
          />
          <span class="message" v-if="v$.clientId.$error">
            {{ $t('INBOX_MGMT.ADD.AUTH.COMMON.REQUIRED_FIELD') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label :class="{ error: v$.apiKey.$error }">
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.API_KEY_LABEL') }}
          <input
            v-model="apiKey"
            type="password"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.API_KEY_PLACEHOLDER')"
            @blur="v$.apiKey.$touch"
          />
          <span class="message" v-if="v$.apiKey.$error">
            {{ $t('INBOX_MGMT.ADD.AUTH.COMMON.REQUIRED_FIELD') }}
          </span>
          <p class="help-text">
            {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.API_KEY_HELP') }}
          </p>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.STORE_NAME_LABEL') }}
          <input
            v-model="storeName"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.STORE_NAME_PLACEHOLDER')"
          />
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.OZON.FORM.CREATE_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
